$(window).on('load', () => {
  console.log('checking notification Load');
  const notificationClose = $('.close-notification');

  $(notificationClose).on('click', function () {
    let notification = $(this).parents('.component-notification')
    notification.hide();
    console.debug("notification.data('callback'): " + notification.data('callback'));
    let callbackMethodName = notification.data('callback');
    if (callbackMethodName && callbackMethodName.length) {
      window[callbackMethodName](notification);
    }
  });



		$.ajax({
			url: '/api/sitecore/Notification/GetWaitTicketNotifications',
			type: 'GET',
			contentType: 'application/json',
			success: function (result) {
				debugger;
				window.customerNotifications = result;
				console.log(customerNotifications);
        if(customerNotifications){
        showWeightNotification(customerNotifications);
        }
			}
		});
	

});

function showWeightNotification(notification){
  if(notification.Data){

  $('#weightNotification').append('<div class="component-notification '+notification.CSSClass+' weight-notification" style="" data-callback="'+notification.JavascriptCallbackMethodName+'" data-notification-data="'+notification.Data+'" data-cm="false">'+
	'<div class="wrapper">'+
		'<div class="component-notification_icon">'+ notification.Icon +
		'</div>'+
		'<div class="align-self-center component-notification_content">'+
    '<div class="notification-title">'+ 	notification.NotificationTitle + '</div>			<div class="notification-message">'
      + notification.NotificationText + 
      '</div></div> '+
      '		<div class="component-notification_action">'+
      '<a href="#" tabindex="0" role="button" aria-pressed="false" onclick="closeWeightNotification()" class="close-notification">'+
        '	<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>'+
        '	<span class="sr-only sr-only-focusable">Close</span> '+
        '</a> 		</div>'+
    '	</div>'+
  '</div>');
  }
}

function closeWeightNotification(){
  console.log('..............');
  // let notification = $(this).parents('.weight-notification');  
  let notification = $('.weight-notification');
  notification.hide();
  console.log('..............' + notification.length );
  // $('#myDiv').hide();
}

function showNotification(type, title, description, leftcta1, leftcta2, rightcta) {
  // First, hide any existing content-managed notifications
  $('.component-notification[data-cm=true]').hide();

  const cssclass = (type !== undefined ? `.${type}` : '');
  const notification = $(`.component-notification${cssclass}`);
  const titleDiv = notification.find('.notification-title');
  const descDiv = notification.find('.notification-message');
  const cta1Div = notification.find('.cta1');
  const cta2Div = notification.find('.cta2');

  if (title && title.length) {
    titleDiv.html(title);
  }

  if (description && description.length) {
    descDiv.html(description);
  }

  if (leftcta1 && leftcta1.length) {
    cta1Div.html(leftcta1);
  }

  if (leftcta2 && leftcta2.length) {
    cta2Div.html(leftcta2);
  }

  if (rightcta && leftcta2.length) {
    cta2Div.html(leftcta2);
  }

  notification.show();

  if (notification && notification.length > 0) {
    $([document.documentElement, document.body]).animate({
      scrollTop: $('.component-notification').offset().top,
    }, 'fast');
  }
  else {
    console.error('Unable to show \'' + type + '\' notification because no notification component has been added to this page. (Title: ' + title + '; Description: ' + description + ')');
  }
}